<template>
  <div
    class="empty-wrapper text-center mt-4 py-12"
    :class="{ 'shaded-light': shaded, 'bg-white': !shaded }"
  >
    <v-icon size="120" color="grey lighten-1" class="mb-4">{{ icon }}</v-icon>

    <h3 class="text-h5 grey--text mb-2">{{ title }}</h3>

    <p v-if="description" class="text-body-1 grey--text">{{ description }}</p>

    <div class="mt-4" v-if="$slots.actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: function() {
        return 'mdi-package-variant';
      },
    },

    title: {
      type: String,
      default: function() {
        return 'No Items Found';
      },
    },

    description: {
      type: String,
    },

    shaded: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-wrapper {
  border: 2px dashed #e0e0e0;

  &.bg-white {
    background: rgba(255, 255, 255, 1);
  }
}
</style>
